import {Component} from "@angular/core";


@Component({
    templateUrl: "./go-page-root.component.html"
})


export class GoPageRootComponent {}


// WEBPACK FOOTER //
// /opt/app/develop/src/app/pages/go/go-page-root.component.ts